/**
 * Handle custom eventListenner on form fields
 */
const formService = {
	/** Paste no more than 10 caracters without whitespace on phone number fields */
	formatPhoneNumber(event: ClipboardEvent) {
		const target = event.target as HTMLInputElement;

		if (event.clipboardData) {
			const pastedText = event.clipboardData.getData('text/plain').replace(/\s/g, '');

			if (target && pastedText.length > 10) {
				target.value = pastedText.substring(pastedText.length - 10);
			}
		}
	}
};

export default formService;
